








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'
import { SettingsModule } from '@/store/modules/settings'
import SidebarItem from './SidebarItem.vue'
import SidebarCustomButton from './SidebarCustomButton.vue'
import SidebarLogo from './SidebarLogo.vue'
import variables from '@/styles/_variables.scss'
import SidebarButtonItem from './SidebarButtonItem.vue';
import ShareService from "@/services/share-service";
import AuthService from "@/services/auth_service";
import { downloadPdfDocument } from '@/services/data/attachment'
import { user_route_ns } from '@/services/data/user_manager'
import UserAccessService from '@/services/user_access_service'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem,
    SidebarLogo,
    SidebarButtonItem,
    SidebarCustomButton,
  }
})
export default class extends Vue {
  public accessService = UserAccessService
  public hidden_names = [ "group_object_constructor" ]
  public isLoaded: boolean = false;

  mounted() {

    console.log("routes", this.routes, this.hidden_names)
    setTimeout(() => {

      const openMenuItems = () => {
        if (!this.isCollapse) {
          const menu = this.$refs.menu as any;
          ['/input', '/documents'].forEach(path => menu.open(path));
        }
      };
      // Открываем при монтировании
      this.$nextTick(openMenuItems);
      // Открываем при смене маршрута
      this.$watch('$route', () => {
        this.$nextTick(openMenuItems);
      });
      if (UserAccessService.checkReadingConstructor().length > 0) {
        this.hidden_names[0] = "none"
      };
      this.hidden_names = [
          ...this.hidden_names,
          ...UserAccessService.checkReadingSummaryDataRoutes()
      ];
      // Открываем при разворачивании меню
      this.$watch('isCollapse', (collapsed: boolean) => {
        if (!collapsed) {
          this.$nextTick(openMenuItems);
        }
      });
      this.$nextTick(openMenuItems)
      this.isLoaded = true

    }, 3000);

  }

  @Watch('accessService.accessHadBeenChanged')
  onAccessChange(newval: any){
    if (newval === true){
      this.hidden_names = []
      if (UserAccessService.checkReadingConstructor().length > 0) {
        this.hidden_names[0] = "none"
      } else {
        this.hidden_names[0] = "group_object_constructor"
      };
      this.hidden_names = [
          ...this.hidden_names,
          ...UserAccessService.checkReadingSummaryDataRoutes()
      ];
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      this.accessService.accessHadBeenChanged = false
    }
    
  }

  currentRoutes(){
    let result: any = []
    result = this.routes.map(
              (route) => 
                {
                  if (route.children){
                    const new_route = JSON.parse(JSON.stringify(route));
                    new_route.children = new_route.children.filter(
                      (child: any) => {
                        return !(this.hidden_names.includes(child.name))   // child.name in this.hidden_names упорно не работает
                      }
                    );
                    return new_route
                  }
                  else {return route}
                }
            )
            result = result.filter((route: any) => {
              return !route.hasOwnProperty('children') || (route.children.length > 0)
            })
    return result
    
  }

  shareService = ShareService;
  authService = AuthService;

  get sidebar() {
    return AppModule.sidebar
  }

  get routes() {
    return PermissionModule.routes
  }

  get showLogo() {
    return SettingsModule.showSidebarLogo
  }

  get menuActiveTextColor() {
    return variables.menuActiveText;
  }

  get variables() {
    return variables
  }

  get activeMenu() {
    const route = this.$route
    const { meta, path } = route
    // if set path, the sidebar will highlight the path you set
    if (meta && meta.activeMenu) {
      return meta.activeMenu
    }
    return path
  }

  get isCollapse() {
    return !this.sidebar.opened
  }

  get defaultOpeneds() {
    // Всегда возвращаем все возможные индексы подменю, чтобы они были открыты по умолчанию
    return ['/input', '/documents', '/admin', '/balance', '/tarifs', '/contragents', '/blocks', '/settings', '/control']
  }

  get openNames() {
    return this.defaultOpeneds
  }

  showAcceptPopup() {
    this.shareService.showAcceptPopup();
  }

  showImportPopup() {
    this.shareService.showImportPopup();
  }

  onSaveManual(type: 'admin' | 'operator') {
    downloadPdfDocument(`${user_route_ns}/user_manual?type=${type}` ,`ДПВТ_00002_01_34_01_Руководство_${type === 'admin' ? 'админист' : 'опе'}ратора.pdf`);
  }
}
